export default {
      id: "siteSatelliteHover-usage",
      viewBox: "0 0 16 20",
      url: __webpack_public_path__ + "icons.svg#siteSatelliteHover",
      toString: function () {
        return this.url;
      }
    }